import { render, staticRenderFns } from "./WhatsHappening.vue?vue&type=template&id=17fd57d7&"
import script from "./WhatsHappening.vue?vue&type=script&lang=js&"
export * from "./WhatsHappening.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports